// ─────────────────────────────────────────────────────────────────────────────
// Content flags
//
// Single source of truth for which content tiers and package types are
// live. Flip these when you're ready to ship — the universe map, packages
// page, and certifications page all read from here.
//
// When flipping a tier flag to true:
//   1. The lessons for that tier must exist in src/content/lessons/ and
//      be registered in lessonIndex.js (the get-lesson function serves any
//      .md present in that folder — there is no registry to update anymore).
//   2. The matching Stripe price IDs and coupon IDs must be set in
//      Netlify env vars: STRIPE_PRICE_TIER{n} and STRIPE_COUPON_TIER{n}_FIRST.
//   3. Tier-relevant capstones must have ID prefixes 't2-', 't3-', 't4-'.
// ─────────────────────────────────────────────────────────────────────────────

export const CONTENT_FLAGS = {
  // Tier content — Foundation (T1) is permanently live; T2/T3/T4 ship later.
  T2_CONTENT_LIVE: false,
  T3_CONTENT_LIVE: false,
  T4_CONTENT_LIVE: false,

  // Software packages — none live at launch.
  PACKAGES_LIVE: false,

  // Cert packages — none live at launch.
  CERTS_LIVE: false,
}
